const padStart = require('../utils/padstart.js');
const config = require('../config');
const { WmPageTpl, BookOrderStatus, TradePayStatus, BookingStatus, StoreType, SendStoreType } = require('../helper/const');
import httpRequest from './http-request-helper';
import fetchHelper from './fetch-helper';
import pageHelper from './page-helper';
import { formatMessage } from '../intl/helper';
import globalMessages from '../intl/messages/global';
import errorMessages from '../intl/messages/error-message';
import { runEnv } from './const';
import emojiRegStr from './getEmojiReg';

exports.getFetchPostParam = params => {
  const requestOptions = Object.assign({}, config.requestOptions, {
    method: 'POST',
    body: JSON.stringify(params),
  });
  return requestOptions;
};

const getUrlParams = (exports.getUrlParams = () => {
  const r = window.location.search.replace(/\?/, '');
  if (!r) {
    return null;
  }

  const items = r.split('&');
  if (!items.length) {
    return null;
  }

  const params = {};
  items.forEach(item => {
    const paramItem = item.split('=');
    if (paramItem.length < 2) {
      return;
    }

    const [key, ...value] = paramItem;
    params[key] = value.join('=');
  });

  return params;
});

// 获取url参数
const getUrlParam = (exports.getUrlParam = param => {
  const params = getUrlParams() || {};

  return params[param] || null;
});

// 将多个url参数组成字符串
exports.formatObjToParamStr = paramObj => {
  if (!paramObj) {
    return '';
  }

  return Object.keys(paramObj)
    .map(key => {
      const value = paramObj[key];
      return value == null ? null : `${key}=${value}`;
    })
    .filter(item => item !== null)
    .join('&');
};

// 设置cookie
exports.setCookie = (name, value, path = '/') => {
  const Days = 30;
  const exp = new Date();

  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);

  document.cookie = `${name}=${value};expires=${exp.toGMTString()};path=${path}`;
};

// 获取cookie
const getCookie = (exports.getCookie = name => {
  const con = document.cookie.match(new RegExp(`(^| )${name}=([^;]*)(;|$)`));

  return con != null ? decodeURI(unescape(con[2], 'utf-8')) : null;
});

// 删除cookie
exports.delCookie = name => {
  const exp = new Date();
  exp.setTime(exp.getTime() - 1);
  const nameT = getCookie(name);

  if (nameT != null) {
    document.cookie = `${name}=${nameT};expires=${exp.toGMTString()};path=/`;
  }
};

// 删除指定域下面的指定cookie
exports.delAppointDomainCookie = cookieObj => {
  const { name, value, path, domain } = cookieObj;
  const exp = new Date();
  exp.setTime(exp.getTime() - 1);

  if (name != null) {
    document.cookie = `${name}=${value};expires=${exp.toGMTString()};path=${path};domain=${domain}`;
  }
};

// 校验手机号
exports.phoneNumber = phone => {
  /* const rule = /(^1([358][0-9]{9})|^1([7][3678][0-9]{8})|^1([4][57][0-9]{8})|(^09[0-9]{8}))$/; */
  const rule = /^[1][3-9]\d{9}$|^([6|9])\d{7}$|^[6]([8|6])\d{5}$/; // 大陆 + 港澳
  return rule.test(phone);
};

exports.replaceEmojiWith = (value, str) => {
  if (!value || typeof value !== 'string') {
    return value;
  }

  const rule = new RegExp(emojiRegStr, 'g');
  return value.replace(rule, str || '');
};

// 校验emoji表情
exports.checkEmojiWith = value => {
  if (!value || typeof value !== 'string') {
    return value;
  }
  const rule = new RegExp(emojiRegStr);
  return !rule.test(value);
};

// 去掉非法字符
exports.replaceInvalidSymbol = (value, str) => {
  if (!value || typeof value !== 'string') {
    return value;
  }
  return value.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5\ ]/g, str || '');
};

// 校验非法字符只包含中文、英文、数字
exports.checkInvalidSymbol = value => {
  if (!value || typeof value !== 'string') {
    return value;
  }
  const rule = /^[a-zA-Z0-9\u4E00-\u9FA5]+$/;
  return rule.test(value);
};

const isWechatMiniProgramBrowser = (exports.isWechatMiniProgramBrowser = () => {
  const ua = navigator.userAgent.toLowerCase();
  return /micromessenger/i.test(ua) && /miniProgram/i.test(ua);
});

const getWeixinVersionInfo = (exports.getWeixinVersionInfo = () => {
  const result = {
    weixin: false,
    version: 0,
  };
  if (isWechatMiniProgramBrowser()) {
    return result;
  }
  const match = /micromessenger\/([\d.]+)/i.exec(navigator.userAgent);
  if (match) {
    result.weixin = true;
    result.version = match[1];
  }
  return result;
});

exports.getOSVersionInfo = () => {
  const result = {
    os: '',
    version: 0,
    versionString: '',
  };

  const userAgent = navigator.userAgent;
  const items = [{ descript: 'android', reg: /(android) (\d+(?:\.\d+)*)/i }, { descript: 'ios', reg: /(iPhone) OS (\d+(?:_\d+)*)/i }];

  items.forEach(item => {
    const { reg } = item;
    const match = reg.exec(userAgent);
    if (!match) {
      return;
    }

    const [, os, versionSource] = match;
    const versionString = versionSource.replace(/\D/g, '.');

    Object.assign(result, {
      os: os.toLowerCase(),
      versionString,
      version: parseFloat(versionString, 10),
    });
  });

  return result;
};

const isAlipayBrowser = (exports.isAlipayBrowser = () => {
  const ua = navigator.userAgent.toLowerCase();
  return /AliApp|AlipayDefined|AlipayClient/i.test(ua) && !/DingTalk/i.test(ua);
});

const isDingTalkBrowser = (exports.isDingTalkBrowser = () => {
  const ua = navigator.userAgent.toLowerCase();
  return /DingTalk/i.test(ua);
});
// 判断支付宝小程序
exports.isAlipayMiniProgramBrowser = () => {
  // return isAlipayBrowser();
  const ua = navigator.userAgent.toLowerCase();
  return isAlipayBrowser() && /miniProgram/i.test(ua);
};

exports.interValSetting = (num, timerEnd) => {
  let cnum = num;
  const timer = setInterval(() => {
    cnum = cnum - 1;
    if (cnum === 0) {
      timerEnd();
      clearInterval(timer);
    }
    sessionStorage.setItem('callBellTime', cnum > 0 ? cnum : '');
  }, 1000);
};

/* 日期 */
exports.dateUtility = {
  format(date, formatStr = 'yyyy-MM-dd') {
    if (!date) {
      return date;
    }

    if (typeof date === 'string') {
      date = this.parse(date);
    }
    if (!(date instanceof Date)) {
      return date;
    }

    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    const result = formatStr
      .replace(/yyyy/, year.toString())
      .replace(/(M+)/, (str, $1) => padStart(month.toString(), $1.length, '0'))
      .replace(/(d+)/, (str, $1) => padStart(date.getDate().toString(), $1.length, '0'))
      .replace(/(H+)/, (str, $1) => padStart(hours.toString(), $1.length, '0'))
      .replace(/(m+)/, (str, $1) => padStart(minutes.toString(), $1.length, '0'))
      .replace(/(s+)/, (str, $1) => padStart(seconds.toString(), $1.length, '0'));
    return result;
  },

  parse(str) {
    if (!str || typeof str !== 'string') {
      return str;
    }

    const [datePart, timePart = '00:00:00'] = str.split(/\s+/);
    const [year, month = 1, day = 1] = datePart.split(/\D+/);
    if (!year) {
      return null;
    }

    const [hours = 0, minutes = 0, seconds = 0] = timePart.split(/\D+/);
    const result = new Date(year, month - 1, day, hours, minutes, seconds);
    return isNaN(+result) ? null : result;
  },
};

const formatPrice = (exports.formatPrice = price => {
  if (!price) {
    return 0;
  }

  if (price.toString().indexOf('.') < 0) {
    return price;
  }

  if (price.toString().split('.')[1].length > 2) {
    return parseFloat(Number(price).toFixed(2));
  }

  return price;
});

// 判断时间是否满一天
exports.renderTime = (startTime, endTime) => {
  if (!startTime || !endTime) {
    return '';
  }
  const formatStartTime = startTime.substring(0, 5);
  const formatEndTime = endTime.substring(0, 5);
  const period =
    Number(formatEndTime.substring(0, 2) * 60) +
    Number(formatEndTime.substring(3, 5)) -
    (Number(formatStartTime.substring(0, 2) * 60) + Number(formatStartTime.substring(3, 5))) +
    1;

  if (period / 60 < 24) {
    return `${formatStartTime}-${formatEndTime}，`;
  }

  return '';
};

// 优惠券可用day展示
exports.renderDay = week => {
  if (!week) return false;

  const regDay = /1{1,}/g; // 匹配一个1或多个1
  let periDay = '';
  let strDay = '';
  let dayIndex = '';
  let days = '';
  // 数据重组
  const str1 = week.substring(0, 1);
  const str2 = week.substr(1, 6);
  const weekFormat = str2 + str1;

  const formatDay = day => {
    switch (day) {
      case 1:
        return formatMessage(globalMessages.monday);
      case 2:
        return formatMessage(globalMessages.tuesday);
      case 3:
        return formatMessage(globalMessages.wednesday);
      case 4:
        return formatMessage(globalMessages.thursday);
      case 5:
        return formatMessage(globalMessages.friday);
      case 6:
        return formatMessage(globalMessages.saturday);
      case 7:
        return formatMessage(globalMessages.sunday);
      default:
        return '';
    }
  };

  if (weekFormat === '1111111') {
    return '';
  }

  while (periDay != null) {
    periDay = regDay.exec(weekFormat);
    if (periDay) {
      dayIndex = periDay.index;
      days = periDay[0];

      if (days.length > 1) {
        strDay += `${formatDay(dayIndex + 1)}${formatMessage(globalMessages.to)}${formatDay(dayIndex + days.length)}，`;
      } else {
        strDay += `${formatDay(dayIndex + 1)}，`;
      }
    }
  }

  if (strDay.indexOf('周一到周五') !== -1) {
    return strDay.replace(/周一到周五/g, '工作日');
  }

  if (strDay === `${formatMessage(globalMessages.saturday)}${formatMessage(globalMessages.to)}${formatMessage(globalMessages.sunday)}，`) {
    return `${formatMessage(globalMessages.weekend)}，`;
  }

  return strDay;
};

// 获取用户昵称
exports.getUserName = userInfo => {
  return userInfo.name;
};

// 获取用户头像
exports.getUserAvatar = userInfo => {
  return userInfo.iconUri;
};

// 保留两位小数的jsPriceCalc (折扣)
exports.jsPriceCalc = (totalPrice, discount) => {
  const value = Number((totalPrice * (1 - discount)).toFixed(3));

  return parseFloat(value.toFixed(2));
};

// 获取当前JS所包含的hash值
exports.getWebpackHashFromScriptUrl = () => {
  const file = (document.currentScript || {}).src || '';
  const substr = file.match(/dist-(\S*)\//);
  let length = 0;

  if (substr && substr[1]) {
    length = substr[1].length + file.indexOf(substr[1]);
    return file.substring(0, length);
  }

  return '';
};

// 验证手机号 新增加199 198 166类型
exports.getPhoneNumberValidate = () => {
  const phoneReg = /^[1][3-9]\d{9}$|^([6|9])\d{7}$|^[6]([8|6])\d{5}$/; // 大陆 + 港澳
  return phoneReg;
};

/**
 * 拼接Url以及参数
 * @param {*} url
 * @param {*} param
 */
const combinationUrl = (exports.combinationUrl = (url, param) => {
  if (!param) {
    return url;
  }

  const paramInit = Object.keys(param).reduce((paramStr, paramItemName) => `${paramStr}&${paramItemName}=${param[paramItemName]}`, '');

  const paramAllStr = paramInit.substring(1);

  return `${url}?${paramAllStr}`;
});

/**
 * 存储cook以及过期时间
 */
const setCook = obj => {
  const { day, name, value, type } = obj;
  const exp = new Date();
  exp.setTime(exp.getTime() + day * 24 * 60 * 60 * 1000); // 过期时间
  document.cookie = `${name}=${value},type=${type};expires=${exp.toGMTString()};path=/`;
};

/**
 * 存储cookie不同的类型，针对堂食点餐页和外卖点餐页
 * @params {*} obj
 */
exports.setCookieTime = obj => {
  const { couponType, type, shopId } = obj;
  let name_ = '';
  if (couponType === 'dishWM') {
    if (type === 'TS') {
      name_ = 'shopId_WM-TS';
    } else if (type === 'WM') {
      name_ = 'shopId_WM';
    }
  } else if (couponType === 'dishTS') {
    name_ = 'shopId_TS';
  }

  setCook({
    day: 0.003,
    name: name_,
    value: shopId,
    type,
  });
};
/* 链接百度地图导航地址
 * @param {当前位置坐标} curPosition
 * @param {目的地坐标} desPosition
 */
exports.getBaiduAPI = (curPosition, desPosition) => {
  if (!curPosition) {
    // 没有开启定位的情况
    return;
  }

  if (curPosition.latlng === 'undefined,undefined') {
    return;
  }

  let destination_ = null;

  if (desPosition.latlng !== ',' && desPosition.commercialAdress) {
    destination_ = `latlng:${desPosition.latlng}|name:${desPosition.commercialAdress}`;
  } else if (desPosition.latlng === ',' && desPosition.commercialAdress) {
    destination_ = desPosition.commercialAdress;
  }
  // 定位到当前位置的情况
  const baiduWeb = combinationUrl('http://api.map.baidu.com/direction', {
    origin: `latlng:${curPosition.latlng}|name:当前位置`,
    destination: destination_,
    mode: 'driving',
    output: 'html',
    origin_region: curPosition.city,
    destination_region: desPosition.city,
    src: 'yourCompanyName|yourAppName',
  });
  location.href = `${baiduWeb}?vt=map`;
};

/**
 * getOrderStatus
 * @param { status }
 */
exports.getOrderStatus = status => {
  const orderStatus = ['已完成', '已确认', '待配送', '正在配送', '配送完成', '已清账', '配送中', '美团外卖', '饿了么', '海底捞App', '已取餐'];

  return orderStatus.includes(status);
};

/* 改变url 参数 */
exports.changeUrlParam = (url, name, value) => {
  let newUrl = '';
  const reg = new RegExp('(^|)' + name + '=([^&]*)(|$)');
  const tmp = `${name}=${value}`;
  if (url.match(reg) != null) {
    newUrl = url.replace(reg, tmp);
  } else {
    if (url.match('[?]')) {
      newUrl = `${url}&${tmp}`;
    } else {
      newUrl = `${url}?${tmp}`;
    }
  }
  return newUrl;
};

/* 广告组广告引入 */
exports.includeAdGroupAdsJS = callback => {
  const time = new Date().getTime();
  const scriptEle = document.createElement('script');
  scriptEle.type = 'text/javascript';
  scriptEle.src = config.env === 'production' ? `https://${config.getAdGroupAdsJsUrl}?v=${time}` : `${config.apiAdsgroup}/static/adWebSdk.min.js?v=${time}`;
  const x = document.getElementsByTagName('head')[0];
  x.appendChild(scriptEle);

  scriptEle.onload = () => {
    // 回调
    callback();
  };
};

/* 引入支付宝JSAPI */
exports.includeAlipayJSApi = callback => {
  const scriptEle = document.createElement('script');
  scriptEle.type = 'text/javascript';
  scriptEle.src = 'https://a.alipayobjects.com/g/h5-lib/alipayjsapi/3.0.2/alipayjsapi.min.js';
  const x = document.getElementsByTagName('head')[0];
  x.appendChild(scriptEle);

  scriptEle.onload = () => {
    // 回调
    callback();
  };
};

/**
 * 缓存参数设置
 */
exports.setParamToSession = param => {
  const sessionParam = getUrlParam(param);

  if (!sessionParam || sessionStorage.getItem(param)) {
    return;
  }

  sessionStorage.setItem(param, sessionParam);
};

/**
 * 获取指定缓存参数
 */
exports.getParamFromSession = param => sessionStorage.getItem(param);

/* 判断门店是否可用 */
exports.getCommericalInfo = (setErrorMsg, callback) => {
  const shopId = getUrlParam('shopId');
  return fetchHelper
    .get(`${config.getCommericalInfoAPI}`, { shopId })
    .then(res => {
      if (res) {
        callback({ enableOnlineCharge: res.enableOnlineCharge, enablePortalStore: res.enablePortalStore });
      }
    })
    .catch((err = {}) => {
      setErrorMsg(err.msg || formatMessage(errorMessages.requestAPIFail));
      console.log(err);
    });
};

/** 计算保留两位小数
 * @param num 传入值
 * @description 使用toFixed(2) 无法四舍五入 75.975这个数字
 */
const fomatFloat = (exports.fomatFloat = num => {
  if (isNaN(num)) return;
  if (Math.floor(num) === num) {
    return num;
  }
  let [intNum, dec] = num.toString().split('.');

  if (dec.length <= 2) {
    return num;
  }
  let [fir, sec, thi] = dec.split('');
  if (thi > 4) {
    sec = Number(sec) + 1;
  }
  if (sec >= 10) {
    sec = 0;
    fir = Number(fir) + 1;
  }
  if (fir >= 10) {
    fir = 0;
    intNum = Number(intNum) + 1;
  }
  const val = `${intNum}.${fir}${sec}`;
  return Number(val);
});

/* 计算储值+赠送金额 */
exports.getTotalRestorePrice = (storeItem, ruleInfo) => {
  const { fullValue, storeType, sendValue, rate } = storeItem;
  const { isFullSend, sendType } = ruleInfo;
  let storePriceTotal = fullValue;

  switch (storeType) {
    case StoreType.SMALLSTORE: {
      // 小额储值
      // storePriceTotal = Math.ceil(orderPrice * (sendValue * 0.01 + 1));
      storePriceTotal = sendValue + fullValue;
      break;
    }
    default: {
      // 正常储值
      // 是否有优惠
      if (isFullSend === 0) {
        if (sendType === SendStoreType.SENDFIXVALUE) {
          // 赠送固定金额
          storePriceTotal = sendValue + fullValue;
        } else if (sendType === SendStoreType.SENDPERCENTVALUE) {
          // 赠送百分比
          storePriceTotal = fullValue + (rate * fullValue) / 100;
        }
      }
      break;
    }
  }

  // 四舍五入 保留两位小数
  storePriceTotal = Number(fomatFloat(storePriceTotal));
  return storePriceTotal;
};

/**
 * 根据nationTelCode选择手机号校验规则
 */
exports.getCurrentPhoneReg = (nationTelCode, countryList = []) => {
  const currentReg = countryList.filter(item => item.areaCode === nationTelCode)[0];
  return { ...currentReg, areaCode: nationTelCode, isAllowSendCode: true };
};

/* 获取推荐菜品 */
exports.getRecommendDish = (businessType, scene) => {
  const shopId = getUrlParam('shopId');
  return fetchHelper
    .post(`${config.recommendDishAPI}?shopId=${shopId}`, { shopId, businessType, scene })
    .then((res = {}) => {
      const dishList = res.dishList || [];
      return dishList;
    })
    .catch(() => []);
};

/**
 * 判定session取出来的数据，是否需要parse
 */
exports.sessionParseData = value => {
  if (!value) {
    return;
  }
  const parseValue = JSON.parse(value);

  if (!value) {
    return;
  }

  if (typeof parseValue === 'object') {
    return parseValue;
  }

  return value;
};

/* 连接菜品和猜你喜欢 */
exports.concatGoodsDetailWithRecommendList = (recommendDishList, dishesDataDuplicate, includeStatus) => {
  let dishesDataDuplicateNew = [];
  const recommendDishListNew = Array.prototype.slice.call(recommendDishList);
  if (!includeStatus) {
    recommendDishList.forEach(item => {
      const findObj = dishesDataDuplicate.find(itemt => itemt.id === item.id);
      if (findObj) {
        dishesDataDuplicateNew.push(Object.assign({}, item, { order: findObj.order }));
      } else {
        dishesDataDuplicateNew.push(item);
      }
    });
  } else {
    dishesDataDuplicate.forEach(item => {
      const findObj = recommendDishListNew.find(itemt => itemt.id === item.id);
      if (findObj) {
        const pos = recommendDishListNew.indexOf(findObj);
        recommendDishListNew.splice(pos, 1);
      }
    });

    dishesDataDuplicateNew = dishesDataDuplicate.concat(recommendDishListNew);
  }
  return dishesDataDuplicateNew;
};

/**
 * getTransferConfig 获取零售跳转链接后缀配置
 */
const getTransferConfig = (exports.getTransferConfig = shopId => {
  httpRequest.get(config.getQryCommercialConfig, { shopId }).then(result => {
    if (!result || !result.data) {
      return;
    }

    if (result.data.showScan) {
      httpRequest.goto(`${config.commodityfeLinkURL(shopId)}scanShopping`);
      return;
    }

    httpRequest.goto(config.commodityfeLinkURL(shopId));
  });
});

/**
 * getTransferURL 获取跳转链接
 */
exports.getTransferURL = param => {
  const { shopId, ...rest } = param;
  const params = { shopId, type: 'WM', ...rest };

  httpRequest.get(config.getRetailAPI, { shopId }).then(res => {
    if (!res || !res.data) {
      return;
    }

    if (res.data.wmPageTpl === WmPageTpl.XLS) {
      getTransferConfig(shopId, params);
      return;
    }

    httpRequest.goto(config.dishMenu4RealtakeoutURL, params);
  });
};

/* 限制输入input textarea */
exports.limitInputAndTextareaMethod = str => {
  const reg = /[^\u4e00-\u9fa5_a-zA-Z0-9^%&',，。;=?$\x22\s\t\n\r]+/g;
  // const regBlank = /\s+/g;
  if (reg.test(str)) {
    return str.replace(reg, '');
  }
  return str;
};

/* 临时方法： 修复cityList数据 */
exports.formatCitylist = cityList => {
  cityList.forEach(item => {
    if (item.name === '长沙') {
      item.pinyin = 'ChangSha';
    }
  });

  return cityList;
};

// 获取用户id
exports.getCustomerId = () => {
  const shopId = getUrlParam('shopId');
  const customerIdKey = 'customerId';
  const customerId = sessionStorage.getItem(customerIdKey);

  if (customerId) return customerId;

  httpRequest.get(`${config.getServiceStatusNoTableAPI}?shopId=${shopId}`, {}).then(res => {
    if (res.code === '200' && res.data.memberVO) {
      sessionStorage.setItem(customerIdKey, res.data.memberVO.customerId);
    }
  });

  return null;
};

/**
 * 获取用户id new
 * 目前大数点埋点
 * 防止高频触发，加一个flag，标识一下。
 */
exports.getCustomerIdNew = () => {
  const shopId = getUrlParam('shopId');
  const customerIdKey = 'customerId';
  const customerId = sessionStorage.getItem(customerIdKey);
  const alreadyInvokeAndError = sessionStorage.getItem('alreadyInvokeCustomerIdAndError');
  if (!shopId) return Promise.resolve(null);
  if (customerId) return Promise.resolve(customerId);
  if (alreadyInvokeAndError === 'true') return Promise.resolve(null);
  return httpRequest.get(`${config.individualAPI}?shopId=${shopId}`, {}).then(res => {
    if (res && res.code === '200' && res.data && res.data.customerId) {
      sessionStorage.setItem(customerIdKey, res.data.customerId);
      return res.data.customerId;
    }
    sessionStorage.setItem('alreadyInvokeCustomerIdAndError', 'true');
    return null;
  });
};

// 阻止页面的双重滚动
exports.preventScrollIntoScroll = (holder, noPreventScrollClassNameList) => {
  let startY = 0;
  const noPreventMoveFunc = item => {
    event.stopPropagation(); // 阻止冒泡
    let shouldPrevent = true;
    if (item.scrollHeight > item.offsetHeight) {
      const endY = event.changedTouches[0].pageY;
      const distanceY = endY - startY;
      const scrollTop = item.scrollTop;
      const scrollHeight = item.scrollHeight;
      const offsetHeight = item.offsetHeight;
      if (
        (scrollTop === 0 && distanceY < 0) ||
        (scrollTop + offsetHeight === item.scrollHeight && distanceY > 0) ||
        (scrollTop > 0 && scrollTop + offsetHeight < scrollHeight)
      ) {
        shouldPrevent = false;
      }
    }
    if (!shouldPrevent) {
      return;
    }
    event.preventDefault();
  };

  const noPreventStartFunc = () => {
    startY = event.changedTouches[0].pageY;
  };

  const holderMoveFunc = () => {
    event.preventDefault();
  };

  const addnoPreventScrollClassNameListMethod = () => {
    noPreventScrollClassNameList.forEach(item => {
      [].slice.call(document.querySelectorAll(`${holder} ${item}`)).forEach((itemt, indext) => {
        itemt.addEventListener('touchmove', event => noPreventMoveFunc(itemt), false);
        itemt.addEventListener('touchstart', noPreventStartFunc, false);
      });
    });
  };

  const cancelnoPreventScrollClassNameListMethod = () => {
    noPreventScrollClassNameList.forEach(item => {
      [].slice.call(document.querySelectorAll(`${holder} ${item}`)).forEach((itemt, indext) => {
        itemt.removeEventListener('touchmove', event => noPreventMoveFunc(itemt), false);
        itemt.removeEventListener('touchstart', noPreventStartFunc, false);
      });
    });
  };

  const addMethod = () => {
    document.querySelector(holder).addEventListener('touchmove', holderMoveFunc, false);
    cancelnoPreventScrollClassNameListMethod();
    addnoPreventScrollClassNameListMethod();
  };

  const cancelMethod = () => {
    document.querySelector(holder).removeEventListener('touchmove', holderMoveFunc, false);
    cancelnoPreventScrollClassNameListMethod();
  };

  return { addMethod, cancelMethod };
};

// 去支付页面
exports.gotoPayUrl = params => {
  const brandId = sessionStorage.getItem('currentBrandId');
  const mid = getCookie(`mid_${brandId}`);
  if (mid) {
    params.mid = mid;
  }

  pageHelper.navigateTo(config.payDetailURL, params);
};

/**
 * validateForeignAreaCode 校验外国区号
 * @param {*} areaCode
 */
exports.validateForeignAreaCode = areaCode => {
  if (!areaCode) {
    return;
  }

  return String(areaCode) === '86' ? '' : `+${areaCode} `;
};

/**
 * 整合bookStatus返回的方法
 */
exports.getTranslateBookStatus = (bookStatus, orderTime, tradePayStatus) => {
  const currentTime = new Date().getTime();
  let translateBookStatus = '';

  switch (bookStatus) {
    case BookOrderStatus.TIMEOUT: {
      if (orderTime < currentTime) {
        translateBookStatus = BookingStatus.BOOKNOTARRIVAL;
        break;
      }
      translateBookStatus = BookingStatus.BOOKSUCCESS;
      break;
    }
    case BookOrderStatus.REFUSE: {
      translateBookStatus = BookingStatus.BOOKREFUSED;
      break;
    }
    case BookOrderStatus.NOTDEAL: {
      if (tradePayStatus === TradePayStatus.NOTPAY) {
        translateBookStatus = BookingStatus.BOOKUNPAID;
        break;
      }

      translateBookStatus = BookingStatus.BOOKCONFIRMING;
      break;
    }
    case BookOrderStatus.USERNOTARRIVAL: {
      if (orderTime < currentTime) {
        translateBookStatus = BookingStatus.BOOKNOTARRIVAL;
        break;
      }

      translateBookStatus = BookingStatus.BOOKSUCCESS;
      break;
    }
    case BookOrderStatus.USERLEAVESHOP: {
      translateBookStatus = BookingStatus.BOOKSUCCESS;
      break;
    }
    case BookOrderStatus.CANCEL: {
      translateBookStatus = BookingStatus.BOOKCANCEL;
      break;
    }
    case BookOrderStatus.USERARRIVAL: {
      translateBookStatus = BookingStatus.BOOKARRIVED;
      break;
    }
    case BookOrderStatus.ASSURE: {
      translateBookStatus = BookingStatus.BOOKSURE;
      break;
    }

    default:
      break;
  }

  return translateBookStatus;
};

/* 临时修改：根据情况判断一些特殊的 none null undefined 类型的字符串 */
exports.filterNoneString = (type, str) => {
  if (!str) {
    return null;
  }
  const reg = /^((https|http|ftp|rtsp|mms)?:\/\/)[^\s]+/;
  switch (type) {
    case 'url': {
      // url网址
      if (!reg.test(str)) {
        return null;
      }
      return str;
    }
    case 'word': {
      // 文字
      const strTolowerCase = str.toLowerCase();
      if (strTolowerCase === 'none' || strTolowerCase === 'undefined' || strTolowerCase === 'null') {
        return null;
      }
      return str;
    }
    default:
      return str;
  }
};

exports.getRunEnv = () => {
  const isWeixin = getWeixinVersionInfo().weixin;

  if (isWeixin) return runEnv.WEIXIN;

  const isWeixinMini = isWechatMiniProgramBrowser();

  if (isWeixinMini) return runEnv.WEIXINMINI;

  const isAlipay = isAlipayBrowser();

  if (isAlipay) return runEnv.ALI;

  return runEnv.GENERAL;
};

// 判断是否是正餐，包括先付和后付
exports.isFormalMeal = form => form === 0 || form === 2;

/**
 * 获取登录用户信息
 * 如果返回false 表示未登录
 */
exports.getLoginUserInfo = () => {
  return fetchHelper
    .get(`${config.individualAPI}`, null, { enableDefaultResponseResolve: false })
    .then((res = {}) => {
      const { data = {} } = res;
      const { code, msg = '', data: info } = data;
      if (code === 'NOT_LOGIN') {
        return false;
      } else if (Number(code) !== 200) {
        throw msg || '系统异常';
      } else {
        return info;
      }
    })
    .catch(ex => {
      throw ex;
    });
};

// 计算菜品价格 - 订单详情页使用
exports.calcMarketPrice = (mainDish = {}) => {
  let totalPrice = 0;
  const groupDishNum = mainDish.num;
  const isGroupDish = mainDish.type === 1;
  const singleDish = (dish = {}, num, subDish) => {
    let marketPrice = 0;
    let marketPriceExtraIngredient = 0;
    let marketPriceExtraPropertyType = 0;
    marketPrice += dish.marketPrice;
    const isWeightMode = dish.saleType === 1; // 称重模式
    if (dish.propertyTypeList && dish.propertyTypeList.length !== 0) {
      dish.propertyTypeList.forEach((item = {}, index) => {
        if (item.properties && item.properties.length !== 0) {
          item.properties.forEach((itemt, indext) => {
            if (itemt.reprice) {
              if (isGroupDish) {
                // marketPriceExtraPropertyType += itemt.reprice * num * groupDishNum;
                marketPriceExtraPropertyType += itemt.reprice * (isWeightMode ? 1 : num) * groupDishNum;
              } else {
                // marketPriceExtraPropertyType += itemt.reprice * num;
                marketPriceExtraPropertyType += itemt.reprice * (isWeightMode ? 1 : num);
              }
            }
          });
        }
      });
    }
    if (dish.dishIngredientInfos && dish.dishIngredientInfos.length !== 0) {
      dish.dishIngredientInfos.forEach((item = {}, index) => {
        if (item.reprice) {
          // 修改配料有可能需要传分数
          if (isGroupDish) {
            marketPriceExtraIngredient += item.reprice * (item.num || 1) * (dish.saleType !== 1 ? num * groupDishNum : 1);
          } else {
            marketPriceExtraIngredient += item.reprice * (item.num || 1) * (dish.saleType !== 1 ? num : 1);
          }
        }
      });
    }
    if (isGroupDish && subDish) {
      marketPrice = marketPrice * num * groupDishNum;
    } else {
      marketPrice = marketPrice * num;
    }
    return Math.max(marketPrice + marketPriceExtraIngredient + marketPriceExtraPropertyType, 0);
  };

  // 但菜品价格计算
  totalPrice += singleDish(mainDish, mainDish.num, false);
  // 多菜品价格计算
  if (mainDish.subDishItems && mainDish.subDishItems.length !== 0) {
    mainDish.subDishItems.forEach((item = {}, index) => {
      if (item.subDishVO && item.subDishVO.length !== 0) {
        item.subDishVO.forEach((itemt = {}, indext) => {
          totalPrice += singleDish(itemt, itemt.num, true);
        });
      }
    });
  }

  return formatPrice(totalPrice);
};



// WEBPACK FOOTER //
// ./src/helper/common-helper.js